/**
 * Asynchronously loads the component for GuestSigningSuccess
 */

import { lazyLoad } from 'utils/loadable';

export const GuestSigningSuccess = lazyLoad(
  () => import('./index'),
  module => module.GuestSigningSuccess,
);
